import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";
import { Overline } from "@/components/ui-bits";
import { Reveal, staggerParent, staggerChild } from "@/components/motion-primitives";

const CHAPTERS = [
  { n: "01", title: "Established 2018", text: "Founded to take the stress out of dealing with municipalities on behalf of property owners and businesses." },
  { n: "02", title: "The Professional Middleman", text: "We sit between you and the municipality, managing queries, applications and investigations end-to-end." },
  { n: "03", title: "Accurate, Managed Accounts", text: "We help ensure municipal accounts are accurately and professionally managed month after month." },
];

export const About = () => (
  <section id="about" className="relative py-24 md:py-32 bg-background overflow-hidden">
    <div className="container mx-auto px-4 md:px-8">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div className="relative rounded-2xl overflow-hidden shadow-[0_30px_80px_-30px_rgba(15,23,42,0.4)]">
              <img src={IMAGES.meeting} alt="SML Municipal Consulting specialists reviewing municipal accounts" className="w-full h-[420px] md:h-[520px] object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/40 to-transparent" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="absolute -bottom-6 -right-2 md:right-6 bg-white rounded-xl shadow-xl px-6 py-5 border border-slate-100">
              <div className="font-heading text-4xl font-semibold text-primary">2018</div>
              <div className="text-xs uppercase tracking-wider text-muted-foreground mt-1">Trusted since</div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal><Overline>About SML Municipal Consulting</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-primary leading-[1.1]">
              We take the stress out of dealing with municipalities.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
              Established in 2018, SML Municipal Consulting assists clients with billing disputes, account
              investigations, corrections, metering, clearance applications, opening and closing accounts,
              refunds and ongoing monthly account management. We position ourselves as the professional
              middleman between you and the municipality &mdash; so you can focus on what matters.
            </p>
          </Reveal>

          <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true }} className="mt-10 grid sm:grid-cols-3 gap-6">
            {CHAPTERS.map((c) => (
              <motion.div key={c.n} variants={staggerChild} className="relative pl-4 border-l-2 border-secondary/30">
                <div className="font-mono text-sm text-secondary font-medium">{c.n}</div>
                <h3 className="mt-2 font-heading text-lg font-semibold text-primary">{c.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{c.text}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);
